module.exports = __webpack_public_path__ + "static/media/sound_dis.d123ed8b.svg";